export default {
  name: 'contactWriteMicroByCountryLastDigit',
  conditions: [
    {
      key: 'idc',
      version: [],
      operator: {
        name: 'matches-regex',
        value: '\\b\\d*[]\\b',
      },
    },
  ],
}
